var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M287.6,458H118.4V54h169.2c4.4,0,7.9-3.6,7.9-7.9V7.9c0-4.4-3.6-7.9-7.9-7.9H91.4c-14.9,0-27,12.1-27,27v458 c0,14.9,12.1,27,27,27h196.2c4.4,0,7.9-3.6,7.9-7.9v-38.1C295.6,461.6,292,458,287.6,458z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,237.6L352,149.7c-3.7-3.7-9.7-3.7-13.4,0l-23.4,23.4c-3.7,3.7-3.7,9.7,0,13.4l40.3,40.3H201.8c-4.7,0-8.6,3.8-8.6,8.6 v36.9c0,4.7,3.8,8.6,8.6,8.6H360l-44.8,44.8c-3.7,3.7-3.7,9.7,0,13.4l23.4,23.4c3.7,3.7,9.7,3.7,13.4,0l87.9-87.9 C450.1,264.2,450.1,247.8,440,237.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.64006b2012f9dc7e9db50d9d1fb26152.svg";
export { ForwardRef as ReactComponent };